(function () {
  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function encode(value) {
    return encodeURIComponent(value || '');
  }

  function setText(selector, value) {
    var node = document.querySelector(selector);
    if (node) {
      node.textContent = value;
    }
  }

  function setHtml(selector, value) {
    var node = document.querySelector(selector);
    if (node) {
      node.innerHTML = value;
    }
  }

  function setLink(selector, href, label) {
    var link = document.querySelector(selector);
    if (!link) {
      return;
    }

    link.setAttribute('href', href);
    if (label) {
      link.textContent = label;
    }
  }

  function hideNode(selector) {
    document.querySelectorAll(selector).forEach(function (node) {
      node.style.display = 'none';
    });
  }

  function removeNode(selector) {
    document.querySelectorAll(selector).forEach(function (node) {
      node.remove();
    });
  }

  function hideIncompleteHomeProduct() {
    document.querySelectorAll('.js-section__home-product, .section--product-featured').forEach(function (section) {
      var jsonNode = section.querySelector('script[id^="ProductJson-"]');
      var titleNode = section.querySelector('.product-featured__title-text');
      var titleText = titleNode ? titleNode.textContent.trim() : '';
      var isOnboarding = jsonNode && jsonNode.textContent.indexOf('"onboarding": true') !== -1;
      var isExample = titleText.indexOf('Example Product Title') !== -1;

      if (isOnboarding || isExample) {
        section.remove();
      }
    });

    removeNode('.placeholder-noblocks');
  }

  function applyHeaderLogo() {
    document.querySelectorAll('.js-main-logo a, .main-logo a, .logo a, .header__logo a, .header-logo a').forEach(function (link) {
      if (link.querySelector('.pegaso-header-logo')) {
        return;
      }

      link.innerHTML =
        '<span class="pegaso-header-logo" aria-label="Pegaso Gallery Design">' +
        '<span class="pegaso-header-logo__main">Pegaso</span>' +
        '<span class="pegaso-header-logo__sub">Gallery Design</span>' +
        '</span>';
    });
  }

  function applyFooterMessaging() {
    document.querySelectorAll('.footer .h5, .site-footer .h5, .footer h4, .site-footer h4').forEach(function (heading) {
      if (heading.textContent.trim().toUpperCase() === 'ASK US:') {
        var container = heading.closest('.footer__block, .footer-block, .o-layout__item, .footer__item') || heading.parentNode;
        var textNode = container ? container.querySelector('p, .rte') : null;
        if (textNode) {
          textNode.innerHTML =
            '<p>Original furniture, antiques, mid-century pieces, lighting, fine art, and decorative objects curated for collectors and designers.</p>' +
            '<p>Monday-Friday 10:00am to 6:00pm</p>' +
            '<p>Saturday 11:00am to 5:00pm</p>' +
            '<p>Closed on Sundays</p>';
        }
      }
    });
  }

  function withNewestSort(urlString) {
    try {
      var url = new URL(urlString, window.location.origin);
      if (url.origin !== window.location.origin) {
        return urlString;
      }

      if (url.pathname.indexOf('/collections/') !== 0) {
        return urlString;
      }

      if (!url.searchParams.get('sort_by')) {
        url.searchParams.set('sort_by', 'created-descending');
      }

      return url.pathname + url.search + url.hash;
    } catch (error) {
      return urlString;
    }
  }

  function appendNewestSortToCollectionLinks() {
    document.querySelectorAll('a[href*="/collections/"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('mailto:') === 0 || href.indexOf('#') === 0) {
        return;
      }

      link.setAttribute('href', withNewestSort(href));
    });
  }

  function enforceNewestFirstCollectionSort() {
    var bodyClasses = document.body.className || '';
    var isCollectionPage = bodyClasses.indexOf('template-collection') !== -1;
    if (!isCollectionPage) {
      return;
    }

    var url = new URL(window.location.href);
    if (!url.searchParams.get('sort_by')) {
      url.searchParams.set('sort_by', 'created-descending');
      window.location.replace(url.toString());
      return;
    }

    var sortSelect = document.getElementById('SortBy');
    if (sortSelect) {
      sortSelect.value = 'created-descending';
    }
  }

  function collapseHeroToSingleSlide() {
    var slides = Array.from(document.querySelectorAll('.js-home-carousel > div'));
    if (!slides.length) {
      return;
    }

    var activeSlide = slides.find(function (slide) {
      var image = slide.querySelector('.home-carousel__bg');
      var source = image ? image.getAttribute('src') : '';
      var hasImage = source && source.indexOf('placeholder') === -1;
      var hasVideo = !!slide.querySelector('.home-carousel__video-video, .js-home-carousel-video-data');
      return hasImage || hasVideo;
    }) || slides[0];

    slides.forEach(function (slide) {
      if (slide !== activeSlide) {
        slide.remove();
      }
    });
  }

  function compressHomepageHeroSpacing() {
    var bodyClasses = document.body.className || '';
    if (bodyClasses.indexOf('template-index') === -1) {
      return;
    }

    var activeItem = document.querySelector('.home-carousel__item[data-slide-id="0"]') ||
      document.querySelector('.js-home-carousel .home-carousel__item');
    if (!activeItem) {
      return;
    }

    var compactHeight = window.innerWidth <= 980 ? 154 : 188;

    [
      '.shopify-section:first-of-type',
      '.shopify-section:first-of-type .section',
      '.home-carousel-wrapper',
      '.home-carousel',
      '.home-carousel__item-wrapper',
      '.js-home-carousel',
      '.flickity-viewport',
      '.flickity-slider',
      '.js-home-carousel > div'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.style.setProperty('min-height', '0', 'important');
        node.style.setProperty('height', compactHeight + 'px', 'important');
        node.style.setProperty('max-height', 'none', 'important');
        node.style.setProperty('margin-top', '0', 'important');
        node.style.setProperty('padding-top', '0', 'important');
        node.style.setProperty('padding-bottom', '0', 'important');
      });
    });

    activeItem.style.setProperty('min-height', compactHeight + 'px', 'important');
    activeItem.style.setProperty('height', compactHeight + 'px', 'important');
    activeItem.style.setProperty('margin-top', '0', 'important');
    activeItem.style.setProperty('padding-top', '0', 'important');
    activeItem.style.setProperty('padding-bottom', '0', 'important');
    activeItem.style.setProperty('align-items', 'center', 'important');
  }

  function normalizeLabel(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function cleanHeaderNavigation() {
    var allowed = {
      home: true,
      collections: true,
      'about us': true,
      contact: true,
      'contact us': true
    };

    document.querySelectorAll(
      '.site-nav li, .site-nav__item, .header-nav li, .main-nav li, .mobile-nav li, .drawer-menu li, .menu li'
    ).forEach(function (item) {
      var link = item.querySelector(':scope > a, :scope > .site-nav__link, :scope > .mobile-nav__link');
      if (!link) {
        return;
      }

      var label = normalizeLabel(link.textContent);
      if (!label) {
        return;
      }

      if (!allowed[label]) {
        item.remove();
      }
    });
  }

  function injectHomepageCategoryLinks() {
    if (document.querySelector('.pegaso-home-categories')) {
      return;
    }

    var sectionTitle = document.querySelector('.home-collection .section__title');
    if (!sectionTitle) {
      return;
    }

    var nav = document.createElement('div');
    nav.className = 'pegaso-home-categories';
    nav.innerHTML =
      '<a class="pegaso-home-categories__link" href="/collections/new-arrivals-1?sort_by=created-descending">New Arrivals</a>' +
      '<a class="pegaso-home-categories__link" href="/collections/lighting?sort_by=created-descending">Lighting</a>' +
      '<a class="pegaso-home-categories__link" href="/collections/tables?sort_by=created-descending">Tables</a>' +
      '<a class="pegaso-home-categories__link" href="/collections/seating?sort_by=created-descending">Seating</a>';
    sectionTitle.insertAdjacentElement('afterend', nav);
  }

  function decodeHtml(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value || '';
    return textarea.value;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function titleToLinkLabel(title) {
    return title === 'New Arrivals' ? 'View all new arrivals' : 'View all ' + title.toLowerCase();
  }

  async function fetchCollectionProducts(handle, limit) {
    var response = await fetch('/collections/' + handle + '?sort_by=created-descending', {
      credentials: 'same-origin'
    });
    var html = await response.text();
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var seen = {};
    var products = [];

    doc.querySelectorAll('.product').forEach(function (productNode) {
      if (products.length >= limit) {
        return;
      }

      var link = productNode.querySelector('a.product-link');
      var media = productNode.querySelector('.product__media');
      var title = productNode.querySelector('.product__title');
      var price = productNode.querySelector('.product__price');

      if (!link || !title || seen[link.href]) {
        return;
      }

      seen[link.href] = true;
      products.push({
        href: link.getAttribute('href') || link.href,
        title: title.textContent.trim(),
        priceHtml: price ? price.innerHTML : '',
        mediaHtml: media ? media.outerHTML : ''
      });
    });

    return products;
  }

  function renderCuratedCards(products) {
    return products
      .map(function (product) {
        return (
          '<article class="pegaso-curated-card">' +
          '<a class="pegaso-curated-card__link" href="' + escapeHtml(product.href) + '">' +
          '<div class="pegaso-curated-card__media">' +
          product.mediaHtml +
          '</div>' +
          '<div class="pegaso-curated-card__body">' +
          '<h3 class="pegaso-curated-card__title">' + escapeHtml(product.title) + '</h3>' +
          '<div class="pegaso-curated-card__price">' + product.priceHtml + '</div>' +
          '</div>' +
          '</a>' +
          '</article>'
        );
      })
      .join('');
  }

  function renderCuratedSectionMarkup(config, products) {
    return (
      '<div class="container container--large">' +
      '<div class="section__title section__title--center">' +
      '<h2 class="section__title-text">' + escapeHtml(config.title) + '</h2>' +
      '</div>' +
      '<div class="pegaso-curated-grid">' +
      renderCuratedCards(products) +
      '</div>' +
      '<div class="section__link section__link--center">' +
      '<a href="/collections/' +
      escapeHtml(config.handle) +
      '?sort_by=created-descending" class="link link--arrow section__link-link">' +
      escapeHtml(config.linkLabel) +
      '</a>' +
      '</div>' +
      '</div>'
    );
  }

  async function buildHomepageShowroom() {
    if (document.querySelector('.pegaso-curated-category')) {
      return;
    }

    var baseSection = document.querySelector('.section[data-section-type="home-collection"]');
    if (!baseSection) {
      return;
    }

    var configs = [
      { handle: 'new-arrivals-1', title: 'New Arrivals' },
      { handle: 'lighting', title: 'Lighting' },
      { handle: 'tables', title: 'Tables' },
      { handle: 'seating', title: 'Seating' }
    ].map(function (config) {
      config.linkLabel = titleToLinkLabel(config.title);
      return config;
    });

    try {
      var results = await Promise.all(
        configs.map(function (config) {
          return fetchCollectionProducts(config.handle, 4);
        })
      );

      baseSection.classList.add('pegaso-curated-category');
      baseSection.innerHTML = renderCuratedSectionMarkup(configs[0], results[0]);

      var insertionPoint = baseSection;
      for (var i = 1; i < configs.length; i += 1) {
        if (!results[i].length) {
          continue;
        }

        var section = document.createElement('section');
        section.className = 'section pegaso-curated-category';
        section.setAttribute('data-pegaso-collection', configs[i].handle);
        section.innerHTML = renderCuratedSectionMarkup(configs[i], results[i]);
        insertionPoint.insertAdjacentElement('afterend', section);
        insertionPoint = section;
      }
    } catch (error) {
      console.error('Pegaso showroom build failed', error);
    }
  }

  function forceTopButtonStyle() {
    var button = document.querySelector('.home-carousel__item[data-slide-id="0"] .home-carousel__btn');
    if (!button) {
      return;
    }

    button.style.setProperty('background', '#17120f', 'important');
    button.style.setProperty('background-color', '#17120f', 'important');
    button.style.setProperty('border', '1px solid #17120f', 'important');
    button.style.setProperty('color', '#fbf8f3', 'important');
    button.style.setProperty('box-shadow', 'none', 'important');
  }

  function forceAnnouncementBarStyle() {
    var selectors = [
      '.announcement',
      '.announcement__link',
      '.announcement__text',
      '.announcement-bar',
      '.announcement-bar__item',
      '.announcement-bar__content',
      '.announcement-bar__message',
      '.announcement-bar__link',
      '.promo-bar',
      '.promo-bar__item',
      '.promo-bar__content',
      '.top-bar',
      '.top-bar__inner',
      '.utility-bar',
      '.utility-bar__inner',
      '.site-announcement',
      '.site-announcement__inner',
      '#shopify-section-announcement-bar',
      '#shopify-section-header-top-bar',
      '[data-section-type="announcement-bar"]',
      '[data-section-type="promo-bar"]'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.style.setProperty('background', '#17120f', 'important');
        node.style.setProperty('background-color', '#17120f', 'important');
        node.style.setProperty('border-color', '#17120f', 'important');
        node.style.setProperty('color', '#f6efe8', 'important');
      });
    });

    selectors
      .map(function (selector) {
        return selector + ' a, ' + selector + ' span, ' + selector + ' p';
      })
      .forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (node) {
          node.style.setProperty('color', '#f6efe8', 'important');
        });
      });
  }

  function cleanHomepageVisuals() {
    document.body.classList.add('pegaso-home-editorial');

    hideIncompleteHomeProduct();

    [
      '#shopify-section-1566456304723',
      '#shopify-section-1566460870233',
      '#shopify-section-1566460912234',
      '#shopify-section-1566460897951',
      '#shopify-section-1566456346591',
      '#shopify-section-1566460938967',
      '.js-section__home-video',
      '.js-section__testimonials',
      '.home-delivery',
      '.home-content',
      '.home-map',
      '.home-image-grid'
    ].forEach(removeNode);

    collapseHeroToSingleSlide();
    hideNode(
      '.home-carousel__nav, .flickity-page-dots, .flickity-prev-next-button, .home-carousel__bg-wrapper, .home-carousel__video'
    );

    setText('.home-carousel__item[data-slide-id="0"] .section__title-text', 'New Arrivals');
    setHtml(
      '.home-carousel__item[data-slide-id="0"] .home-carousel__text',
      ''
    );
    setText('.home-carousel__item[data-slide-id="0"] .home-carousel__btn', 'Shop New Arrivals');
    setLink(
      '.home-carousel__item[data-slide-id="0"] .home-carousel__btn',
      '/collections/new-arrivals-1?sort_by=created-descending'
    );
    compressHomepageHeroSpacing();
    forceTopButtonStyle();
    window.setTimeout(forceTopButtonStyle, 200);
    window.setTimeout(forceTopButtonStyle, 800);
    window.setTimeout(compressHomepageHeroSpacing, 150);
    window.setTimeout(compressHomepageHeroSpacing, 600);

    setText('.home-collection .section__title-text', 'New Arrivals');
    setLink(
      '.home-collection .section__link-link',
      '/collections/new-arrivals-1?sort_by=created-descending',
      'View all new arrivals'
    );

    appendNewestSortToCollectionLinks();
    forceAnnouncementBarStyle();
    buildHomepageShowroom();
  }

  function applyCollectionCardFrames() {
    var bodyClasses = document.body.className || '';
    if (bodyClasses.indexOf('template-collection') === -1) {
      return;
    }

    document.querySelectorAll('.product-grid-item, .product-block, .grid-product, .product-item').forEach(function (card) {
      card.style.setProperty('border', '1px solid rgba(94, 75, 60, 0.14)', 'important');
      card.style.setProperty('padding', '0.7rem', 'important');
      card.style.setProperty('background', '#efe7dc', 'important');
    });

    document
      .querySelectorAll(
        '.product-top, .product__media, .grid-product__image-wrap, .grid-product__image-mask, .product-item__image-wrapper'
      )
      .forEach(function (frame) {
        frame.style.setProperty('padding', '0.55rem', 'important');
        frame.style.setProperty('border', '1px solid rgba(94, 75, 60, 0.14)', 'important');
        frame.style.setProperty('background', '#efe7dc', 'important');
        frame.style.setProperty('box-shadow', 'inset 0 0 0 1px rgba(255, 250, 244, 0.72)', 'important');
      });

    document
      .querySelectorAll('.product__media .o-ratio, .product__media .o-ratio__content, .grid-product__image-mask, .product-item__image')
      .forEach(function (innerMedia) {
        innerMedia.style.setProperty('background', '#efe7dc', 'important');
      });
  }

  function applyHomepageEndingDivider() {
    document.querySelectorAll('.pegaso-ending-divider').forEach(function (node) {
      node.remove();
    });
  }

  function cleanProductPurchaseUi() {
    hideNode(
      '.shopify-payment-button, .shopify-payment-button__button, .shopify-payment-button__more-options, .product-single__qty, .product-single__quantity, .product-form__quantity, .quantity-selector, .quantity-wrapper, .quantity'
    );
  }

  function extractDimensionsText() {
    var containers = document.querySelectorAll(
      '.product-single__content-text, .product-description, .product__description, .rte, [itemprop="description"]'
    );

    for (var i = 0; i < containers.length; i += 1) {
      var text = (containers[i].innerText || containers[i].textContent || '').replace(/\u00a0/g, ' ');
      if (!/dimensions\s*:/i.test(text)) {
        continue;
      }

      var lines = text
        .split('\n')
        .map(function (line) {
          return line.replace(/\s+/g, ' ').trim();
        })
        .filter(Boolean);

      for (var j = 0; j < lines.length; j += 1) {
        if (!/dimensions\s*:/i.test(lines[j])) {
          continue;
        }

        var sameLineValue = lines[j].replace(/^.*dimensions\s*:\s*/i, '').trim();
        if (sameLineValue) {
          return sameLineValue;
        }

        var nextLines = [];
        for (var k = j + 1; k < lines.length && nextLines.length < 3; k += 1) {
          if (/^(origin|date|condition|materials?|shipping|sku|availability|details?)\b/i.test(lines[k])) {
            break;
          }

          nextLines.push(lines[k]);

          if (/[0-9](\"|in\.|cm|mm|w\b|h\b|d\b)/i.test(lines[k])) {
            break;
          }
        }

        if (nextLines.length) {
          return nextLines.join(' ');
        }
      }
    }

    return '';
  }

  function injectDimensionsBlock() {
    var bodyClasses = document.body.className || '';
    if (bodyClasses.indexOf('template-product') === -1) {
      return;
    }

    var dimensions = extractDimensionsText();
    if (!dimensions) {
      return;
    }

    var existing = document.querySelector('.pegaso-product-dimensions');
    if (existing) {
      existing.querySelector('.pegaso-product-dimensions__value').textContent = dimensions;
      return;
    }

    var block = document.createElement('div');
    block.className = 'pegaso-product-dimensions';
    block.innerHTML =
      '<span class="pegaso-product-dimensions__label">Dimensions</span>' +
      '<div class="pegaso-product-dimensions__value"></div>';
    block.querySelector('.pegaso-product-dimensions__value').textContent = dimensions;

    var anchor =
      document.querySelector('.product-single__price') ||
      document.querySelector('.product-single__content') ||
      document.querySelector('.product-single__add');

    if (anchor && anchor.parentNode) {
      anchor.insertAdjacentElement('afterend', block);
    }
  }

  function forceProductTitleColor() {
    var bodyClasses = document.body.className || '';
    if (bodyClasses.indexOf('template-product') === -1) {
      return;
    }

    document
      .querySelectorAll('.product-single__title, .product__title, .section__title-text, .product-title, h1')
      .forEach(function (title) {
        title.style.setProperty('color', '#17120f', 'important');
      });

    document
      .querySelectorAll('.product-single__title a, .product__title a, .product-title a, .breadcrumb a')
      .forEach(function (link) {
        link.style.setProperty('color', '#17120f', 'important');
      });
  }

  ready(function () {
    document.documentElement.classList.add('pegaso-luxury-ready');
    applyHeaderLogo();
    applyFooterMessaging();
    cleanHeaderNavigation();
    appendNewestSortToCollectionLinks();
    enforceNewestFirstCollectionSort();
    forceAnnouncementBarStyle();

    var bodyClasses = document.body.className || '';
    var isProductPage = bodyClasses.indexOf('template-product') !== -1;
    var isHomePage = bodyClasses.indexOf('template-index') !== -1;

    hideNode('.js-cart-trigger');

    if (isHomePage) {
      cleanHomepageVisuals();
    }

    applyCollectionCardFrames();
    applyHomepageEndingDivider();
    window.setTimeout(forceAnnouncementBarStyle, 200);
    window.setTimeout(forceAnnouncementBarStyle, 800);
    window.setTimeout(applyCollectionCardFrames, 220);
    window.setTimeout(applyCollectionCardFrames, 900);
    window.setTimeout(applyHomepageEndingDivider, 220);
    window.setTimeout(applyHomepageEndingDivider, 900);

    if (!isProductPage) {
      return;
    }

    var titleNode = document.querySelector('.product-single__title, h1');
    var productTitle = titleNode ? titleNode.textContent.trim() : document.title.replace(/\s+[\u2013\-].*$/, '');
    var productUrl = window.location.href;
    var contactUrl =
      '/pages/contact?subject=' +
      encode('Inquiry about ' + productTitle) +
      '&product=' +
      encode(productTitle) +
      '&url=' +
      encode(productUrl);
    var emailUrl =
      'mailto:info@pegasogallerydesign.com?subject=' +
      encode('Inquiry about ' + productTitle) +
      '&body=' +
      encode('I would like more information about ' + productTitle + '.\n\nProduct page: ' + productUrl);

    document.querySelectorAll('.js-product-add-text').forEach(function (textNode) {
      textNode.textContent = 'Inquire About This Piece';
    });

    cleanProductPurchaseUi();
    injectDimensionsBlock();
    forceProductTitleColor();
    window.setTimeout(cleanProductPurchaseUi, 250);
    window.setTimeout(cleanProductPurchaseUi, 900);
    window.setTimeout(injectDimensionsBlock, 250);
    window.setTimeout(injectDimensionsBlock, 900);
    window.setTimeout(forceProductTitleColor, 250);
    window.setTimeout(forceProductTitleColor, 900);

    document.querySelectorAll('.js-product-add').forEach(function (button) {
      button.setAttribute('aria-label', 'Inquire about ' + productTitle);
      button.setAttribute('title', 'Inquire about ' + productTitle);
    });

    document.querySelectorAll('form.js-product-form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        window.location.href = contactUrl;
      });
    });

    document.querySelectorAll('.product-single__add').forEach(function (container) {
      if (container.parentNode && container.parentNode.querySelector('.pegaso-inquiry-links')) {
        return;
      }

      var wrapper = document.createElement('div');
      wrapper.className = 'pegaso-inquiry-links';

      var note = document.createElement('p');
      note.className = 'pegaso-inquiry-note';
      note.textContent =
        'Questions about condition, shipping, provenance, or availability? Contact the gallery team directly for a tailored response.';

      var actions = document.createElement('div');
      actions.className = 'pegaso-inquiry-actions';

      var contactLink = document.createElement('a');
      contactLink.className = 'pegaso-inquiry-link';
      contactLink.href = contactUrl;
      contactLink.textContent = 'Send Inquiry';

      var emailLink = document.createElement('a');
      emailLink.className = 'pegaso-inquiry-link pegaso-inquiry-link--secondary';
      emailLink.href = emailUrl;
      emailLink.textContent = 'Email the Gallery';

      actions.appendChild(contactLink);
      actions.appendChild(emailLink);
      wrapper.appendChild(note);
      wrapper.appendChild(actions);
      container.insertAdjacentElement('afterend', wrapper);
    });
  });
})();
